// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Draggable {\n  cursor: -webkit-grab;\n  cursor: grab; }\n  .Draggable__Item {\n    margin-top: 5px;\n    margin-bottom: 5px;\n    display: -webkit-box;\n    align-content: center; }\n  .Draggable__Holder {\n    display: block;\n    width: 25px;\n    justify-content: center;\n    align-items: center; }\n", ""]);
// Exports
module.exports = exports;
